// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__n3oeQ","filter":"Card_filter__xkLhv","imageCard":"Card_imageCard__qVxFK","accommodationTitle":"Card_accommodationTitle__5x2mI"};